import { FC, useEffect, useRef } from "react";

import { useBulkContext } from "@/common/contexts/BulkContext";

interface TableSelectionResetProps {
  filterIdentity: string;
}

export const TableSelectionReset: FC<TableSelectionResetProps> = ({ filterIdentity }) => {
  const { resetBulkSelect } = useBulkContext();
  // Starts at the mounted identity so a pre-selection given to the provider survives the first render.
  const appliedIdentity = useRef(filterIdentity);

  useEffect(() => {
    if (appliedIdentity.current === filterIdentity) {
      return;
    }
    appliedIdentity.current = filterIdentity;
    resetBulkSelect([]);
  }, [filterIdentity, resetBulkSelect]);

  return null;
};
